import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import React from "react";

const useStyles = theme => ({
  listItem: {
    padding: theme.spacing(1, 0)
  },
  total: {
    fontWeight: "700"
  },
  title: {
    marginTop: theme.spacing(2)
  }
});

const noWrap = { whiteSpace: "nowrap" };

export default function Review(props) {
  console.log(props.products);
  const { products, planDetails } = props;

  const planPlusProduct = [...planDetails, ...products];
  let totalAmount =
    planPlusProduct.length !== 0 &&
    planPlusProduct
      .map(item => item.fees * item.quantity)
      .reduce((prev, next) => prev + next);
  const tax = (2 * totalAmount) / 100;
  totalAmount = totalAmount + tax;
  const shipping = [
    {
      id: 1,
      name: "Shipping charges",
      desc: "",
      quantity: 1,
      fees: "Free"
    }
  ];

  const selectedProducts = [...planPlusProduct, ...shipping];
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Order summary
      </Typography>
      <List disablePadding>
        {selectedProducts.map(product => (
          <ListItem key={product.name}>
            <ListItemText
              primary={
                product.productCode
                  ? `${product.name} (Quantity: ${product.quantity})`
                  : product.name
              }
              secondary={product.desc}
            />
            <Typography variant="subtitle1" style={noWrap}>
              {!product.name.includes("Shipping")
                ? `$ ${product.quantity * product.fees}`
                : product.fees}
            </Typography>
          </ListItem>
        ))}
        <ListItem>
          <ListItemText primary="Taxes" />
          <Typography variant="subtitle1" style={noWrap}>
            $ {tax}
          </Typography>
        </ListItem>
        <ListItem>
          <ListItemText primary="Total" />
          <Typography variant="subtitle1">$ {totalAmount}</Typography>
        </ListItem>
      </List>
      <hr />
      <Grid container spacing={8}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom>
            Shipping Address
          </Typography>
          <Typography
            style={{ fontWeight: "bold" }}
            gutterBottom
          >{`${props.values.firstName} ${props.values.lastName}`}</Typography>
          <Typography gutterBottom>{props.values.streetAddress}</Typography>
          <Typography
            gutterBottom
          >{`${props.values.town} ${props.values.state}`}</Typography>
          <Typography
            gutterBottom
          >{`${props.values.country} ${props.values.zipCode}`}</Typography>
          <div style={{ display: "flex", marginLeft: 10 }}>
            <Typography
              style={{ fontWeight: "bold", marginLeft: 0 }}
              gutterBottom
            >{`Contact Number: ${"\xa0\xa0"}`}</Typography>
            {props.values.contactNo}
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/public/Checkout/Review.js